import styled from 'styled-components'
import palette from 'theme/palette'

const CountBadge = styled.span`
  background: ${palette.danger.color};
  color: #ffffff;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`

export default CountBadge
